import React from 'react'
import { AssessmentAnswersFilter } from 'utils/filters'
import { DerivedFilterToggle, FilterToggle } from './FilterToggle'

export const AssessmentAnswersFilterToggle: DerivedFilterToggle = (props) => (
    <FilterToggle {...props} count={AssessmentAnswersFilter.useCount()} />
)
